var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-animation',{attrs:{"type":'success',"text":'Perfeito! Agora divulgue a novidade para seus clientes e aumente o desejo deles!'}}),_c('base-card',[_c('div',{staticClass:"img"},[_c('div')])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }